import { render, staticRenderFns } from "./Aproblem.vue?vue&type=template&id=02aa8be0&scoped=true"
import script from "./Aproblem.vue?vue&type=script&lang=js"
export * from "./Aproblem.vue?vue&type=script&lang=js"
import style0 from "./Aproblem.vue?vue&type=style&index=0&id=02aa8be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aa8be0",
  null
  
)

export default component.exports